import { styled } from '@mui/material';

import type { PillVariant } from './status-pill';

const variantStyles: Record<PillVariant, object> = {
  progress: {
    backgroundColor: '#0368A3',
    color: '#FFFFFF',
    padding: '3px 9px',
  },
  active: {
    backgroundColor: '#D7FFE4',
    color: '#000000',
    padding: '2px 8px',
  },
  selected: {
    backgroundColor: '#EFEFEF',
    color: '#000000',
    padding: '2px 8px',
  },
  new: {
    background:
      'linear-gradient(115deg, #F8FF8C 0%, #FBFDBE 24%, #DDD7FF 59%, #E2DEF9 67%, #EDEEFF 76%, #FFFFFF 87%)',
    color: '#000000',
    padding: '4px 8px',
  },
  inProgress: {
    backgroundColor: '#FFDCA8',
    color: '#55370D',
    padding: '3px 9px',
  },
  verified: {
    backgroundColor: '#D7FFE4',
    color: '#174927',
    padding: '3px 9px',
  },
  closed: {
    backgroundColor: '#EFEFEF',
    color: '#444444',
    padding: '3px 9px',
  },
};

export const PillRoot = styled('span', {
  shouldForwardProp: prop => prop !== '$variant',
})<{ $variant: PillVariant }>(({ $variant }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: '29px',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '15px',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  ...variantStyles[$variant],
}));
